import React, { useEffect, useState } from "react";
import {
  Col,
  Form,
  Input,
  Row,
  Select,
  Space,
  Timeline,
  TimePicker,
} from "antd";
import Checkbox from "antd/es/checkbox/Checkbox";
import { authSelector } from "../../auth/authSlice";
import { useSelector } from "react-redux";
import {
  CUSTOMER_DISPLAY_NAME,
  CUSTOMER_FULL_SHIPPING_ADDRESS_STR,
  CUSTOMER_SHIPPING_ADDRESS,
  CUSTOMER_SHIPPING_CITY,
  CUSTOMER_SHIPPING_STATE,
  CUSTOMER_SHIPPING_ZIP,
  RETURN_METHOD_DROPOFF,
  RETURN_METHOD_ONSITE,
  VENUE_NAME,
} from "../../../app/utils/models/modelConstants/modelConstants";
import { capitalizeFirstLetter } from "../../../app/utils/casing/capitalizeFirstLetter";
import LocationTag from "./LocationTag";
import TextSubtitle from "../../../app/system-components/typography/text/TextSubtitle";
import { useFirestore } from "react-redux-firebase";
import { getObjFromId } from "../helpers/getObjFromId";

const { Option } = Select;
const ReturnDetails = ({
  isSalesInvoice,
  rentalDates,
  setSpecifiedTimes,
  specifiedTimes,
  form,
  item,
  returnMethod,
  setCustomerAddressChecked,
  customerAddressChecked,
  handleReturnMethod,
  customer,
  loadVenues,
  venues,
  currentInvoice,
  id,
}) => {
  const { orgData, userData, fsOrgPrefix } = useSelector(authSelector);
  const [loading, setLoading] = useState(false);
  const [venueInput, setVenueInput] = useState("");
  const [returnVenue, setReturnVenue] = useState(null);
  const validateTime = (rule, val) => {
    return new Promise((res, rej) => {
      if (
        specifiedTimes.return &&
        (val === null || typeof val === "undefined")
      ) {
        rej();
      }
      res();
    });
  };

  useEffect(() => {
    if (customerAddressChecked.return && customer) {
      const {
        customerDisplayName,
        customerShippingAddress,
        customerShippingCity,
        customerShippingState,
        customerShippingZip,
      } = customer;
      form.setFieldsValue({
        [`${returnMethod}${capitalizeFirstLetter(CUSTOMER_DISPLAY_NAME)}`]:
          customerDisplayName,
        [`${returnMethod}${capitalizeFirstLetter(CUSTOMER_SHIPPING_ADDRESS)}`]:
          customerShippingAddress,
        [`${returnMethod}${capitalizeFirstLetter(CUSTOMER_SHIPPING_CITY)}`]:
          customerShippingCity,
        [`${returnMethod}${capitalizeFirstLetter(CUSTOMER_SHIPPING_STATE)}`]:
          customerShippingState,
        [`${returnMethod}${capitalizeFirstLetter(CUSTOMER_SHIPPING_ZIP)}`]:
          customerShippingZip,
      });
    }
  }, [customerAddressChecked, customer]);

  const handleReturnVenueSelected = (e) => {
    const returnVenue = getObjFromId(e, venues, customer);
    if (returnVenue) {
      // save info to state
      setReturnVenue(returnVenue);
      const venueContactName = returnVenue?.venueContactName ?? null;
      const venueAddress = returnVenue?.venueAddress ?? null;
      const venueCity = returnVenue?.venueCity ?? null;
      const venueState = returnVenue?.venueState ?? null;
      const venueZip = returnVenue?.venueZip ?? null;
      const venueNotes = returnVenue?.venueNotes ?? null;
      const customerDisplayName = customer?.customerDisplayName ?? null;
      console.log("the customer: ", customer);
      form.setFieldsValue({
        [`${returnMethod}${capitalizeFirstLetter(CUSTOMER_DISPLAY_NAME)}`]:
          venueContactName ? venueContactName : customerDisplayName,
        [`${returnMethod}${capitalizeFirstLetter(CUSTOMER_SHIPPING_ADDRESS)}`]:
          venueAddress,
        [`${returnMethod}${capitalizeFirstLetter(CUSTOMER_SHIPPING_CITY)}`]:
          venueCity,
        [`${returnMethod}${capitalizeFirstLetter(CUSTOMER_SHIPPING_STATE)}`]:
          venueState,
        [`${returnMethod}${capitalizeFirstLetter(CUSTOMER_SHIPPING_ZIP)}`]:
          venueZip,
        [`notes`]: venueNotes,
      });
    }
  };

  return (
    <Timeline.Item style={{ paddingBottom: "24px" }}>
      <div>
        <Space style={{ alignItems: "center" }}>
          <span style={{ fontWeight: "bold" }}>{rentalDates.returnDate}</span>
          Items returned by:
          <Form.Item
            name="returnMethod"
            style={{ marginBottom: 0 }}
            initialValue={RETURN_METHOD_ONSITE}
          >
            <Select
              defaultValue={RETURN_METHOD_ONSITE}
              onChange={handleReturnMethod}
              style={{ width: "160px" }}
            >
              <Option key={RETURN_METHOD_ONSITE} value={RETURN_METHOD_ONSITE}>
                On site pickup
              </Option>
              <Option key={RETURN_METHOD_DROPOFF} value={RETURN_METHOD_DROPOFF}>
                Customer drop off
              </Option>
            </Select>
          </Form.Item>
          <Form.Item
            name="hasSpecifiedReturnTime"
            initialValue={false}
            valuePropName="checked"
            style={{ marginBottom: 0 }}
          >
            <Checkbox
              style={{ marginLeft: "12px" }}
              onChange={(e) => {
                setSpecifiedTimes({
                  return: e.target.checked,
                  receive: specifiedTimes.receive,
                });
                if (!e.target.checked) {
                  form.setFieldsValue({
                    specifiedReturnTime: null,
                    specifiedReturnTimeEnd: null,
                  });
                }
              }}
            >
              Specify time
            </Checkbox>
          </Form.Item>
          <Form.Item
            className="FormItemNoValidatonMargin"
            name="specifiedReturnTime"
            style={{ marginBottom: 0 }}
            initialValue={null}
            rules={[{ validator: validateTime }]}
          >
            {specifiedTimes.return ? (
              <TimePicker
                style={{ width: "140px" }}
                use12Hours
                format="h:mm a"
              />
            ) : null}
          </Form.Item>
          <Form.Item
            className="FormItemNoValidatonMargin"
            name="specifiedReturnTimeEnd"
            style={{ marginBottom: 0 }}
            initialValue={null}
          >
            {specifiedTimes.return ? (
              <TimePicker
                placeholder="End (Optional)"
                style={{ width: "140px" }}
                use12Hours
                format="h:mm a"
              />
            ) : null}
          </Form.Item>
          {specifiedTimes.return && (
            <TextSubtitle text={"(Use end time for ranges)"} />
          )}
        </Space>
      </div>

      {returnMethod === RETURN_METHOD_ONSITE &&
      !customerAddressChecked.return ? (
        <div>
          <Checkbox
            style={{ marginTop: "20px" }}
            defaultChecked={customerAddressChecked.return}
            checked={customerAddressChecked.return}
            onChange={(e) => {
              setCustomerAddressChecked({
                return: e.target.checked,
                receive: customerAddressChecked.receive,
              });
            }}
          >
            Use customer shipping address
          </Checkbox>
          {/* <div style={{ margin: "10px 0px 10px 0px" }}>
            Select a saved venue or enter a custom shipping address.
          </div> */}
          <Form.Item
            style={{ margin: "20px 0px 30px 0px" }}
            name="returnVenueQueryHook"
            className="NewInvoiceVenueForm"
          >
            <Select
              loading={loading}
              onSearch={setVenueInput}
              allowClear
              onClear={() => {
                setReturnVenue(null);
              }}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
              onSelect={handleReturnVenueSelected}
              showSearch
              onFocus={loadVenues}
              placeholder={"Select existing venue"}
              style={{ width: "416px" }}
            >
              {venues &&
                venues.map((c) => (
                  <Option value={c.id} key={c.id}>
                    {c[VENUE_NAME]}
                  </Option>
                ))}
            </Select>
          </Form.Item>
          <div>
            <Form.Item
              className="NewInvoiceCustomerForm"
              name={`${returnMethod}${capitalizeFirstLetter(
                CUSTOMER_DISPLAY_NAME
              )}`}
              initialValue=""
              rules={[
                {
                  required: true,
                  message: "Name required",
                },
              ]}
            >
              <Input
                placeholder="Contact name"
                style={{ width: "416px" }}
                disabled={customerAddressChecked.return}
              />
            </Form.Item>
            <Form.Item
              initialValue=""
              className="NewInvoiceCustomerForm"
              name={`${returnMethod}${capitalizeFirstLetter(
                CUSTOMER_SHIPPING_ADDRESS
              )}`}
              rules={[
                {
                  required: true,
                  message: "Address required",
                },
              ]}
            >
              <Input
                placeholder="Customer address"
                style={{ width: "416px" }}
                disabled={customerAddressChecked.return}
              />
            </Form.Item>
            <Row wrap={false} gutter={8}>
              <Col>
                <Form.Item
                  initialValue=""
                  className="NewInvoiceCustomerForm"
                  name={`${returnMethod}${capitalizeFirstLetter(
                    CUSTOMER_SHIPPING_CITY
                  )}`}
                  rules={[
                    {
                      required: true,
                      message: "City required",
                    },
                  ]}
                >
                  <Input
                    placeholder="City"
                    style={{ width: "200px" }}
                    disabled={customerAddressChecked.return}
                  />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item
                  initialValue=""
                  className="NewInvoiceCustomerForm"
                  name={`${returnMethod}${capitalizeFirstLetter(
                    CUSTOMER_SHIPPING_STATE
                  )}`}
                  rules={[
                    {
                      required: true,
                      message: "State required",
                    },
                  ]}
                >
                  <Input
                    placeholder="State"
                    style={{ width: "100px" }}
                    disabled={customerAddressChecked.return}
                  />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item
                  initialValue=""
                  className="NewInvoiceCustomerForm"
                  name={`${returnMethod}${capitalizeFirstLetter(
                    CUSTOMER_SHIPPING_ZIP
                  )}`}
                  rules={[
                    {
                      required: true,
                      message: "Zip required",
                    },
                  ]}
                >
                  <Input
                    placeholder="Zip"
                    style={{ width: "100px" }}
                    disabled={customerAddressChecked.return}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </div>
      ) : returnMethod === RETURN_METHOD_ONSITE &&
        customerAddressChecked.return ? (
        <div>
          <Checkbox
            checked={customerAddressChecked.return}
            style={{ marginTop: "20px" }}
            defaultChecked={customerAddressChecked.return}
            onChange={(e) => {
              setCustomerAddressChecked({
                return: e.target.checked,
                receive: customerAddressChecked.receive,
              });
            }}
          >
            Use customer shipping address
          </Checkbox>
          <br />
          <LocationTag
            contactName={customer && customer[CUSTOMER_DISPLAY_NAME]}
            address={customer && customer[CUSTOMER_FULL_SHIPPING_ADDRESS_STR]}
          />
        </div>
      ) : (
        <LocationTag address={orgData && orgData.companyAddress} />
      )}
    </Timeline.Item>
  );
};

export default ReturnDetails;
